"use client";

import { createContext, useContext } from "react";

import type { MailtechDatabase } from "@/database/initialize";

/**
 * React context carrying the local RxDB database, or `null` before init
 * resolves / after init fails. Owned by us instead of rxdb's
 * RxDatabaseContext because rxdb's `useRxDatabase`/`useRxCollection` THROW
 * (error R2) when no provider is mounted — which is exactly the state every
 * authed surface renders in while IndexedDB opens, since DatabaseProvider
 * always renders children (degraded, never blank). Reading this context is
 * always null-safe.
 */
export const DatabaseReactContext = createContext<MailtechDatabase | null>(
  null,
);

/** The local RxDB database, or `null` while it is pending or failed. */
export function useDatabaseOptional(): MailtechDatabase | null {
  return useContext(DatabaseReactContext);
}
